import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

import { ordersApi } from 'src/api';

import { setOrderErrors, setOrdersMeta, setSelectedOrder } from './orders.slice';

import { ROUTE } from 'src/constants';
import { dumpAcceptOrder, dumpCreateOrder, normalizeErrorResponse } from 'src/utils';

export const getOrders = createAsyncThunk('orders/get-orders', async (data, thunkApi) => {
  try {
    const copiedPayload = _.cloneDeep(data);

    for (const key in copiedPayload) {
      if (!copiedPayload[key]?.length) {
        delete copiedPayload[key];
      }
    }

    const response = await ordersApi.getOrders(data);

    thunkApi.dispatch(setOrdersMeta(response?.meta));

    return response?.data;
  } catch (error) {
    console.error(error);
  }
});

export const createOrder = createAsyncThunk('orders/create-order', async (data, thunkApi) => {
  try {
    const { navigate, payload } = data;

    const copiedPayload = _.cloneDeep(payload);

    const response = await ordersApi.createOrder(copiedPayload);

    navigate(`/exchange/${response?.data}/view`);

    return response;
  } catch (error) {
    const { response } = error;

    thunkApi.dispatch(setOrderErrors(normalizeErrorResponse(response.data.errors)));
  }
});

export const getEditOrder = createAsyncThunk('orders/get-edit-order', async (data) => {
  try {
    const { id, navigate } = data;

    const response = await ordersApi.getEditOrder(id);

    if (response?.data?.status !== 'PENDING') {
      navigate(`/exchange/${id}/status`);
    }

    return response?.data;
  } catch (error) {
    const { navigate } = data;

    navigate(ROUTE.HOME);

    console.error(error);
  }
});

export const getPollingEditOrder = createAsyncThunk(
  'orders/get-polling-edit-order',
  async (data) => {
    try {
      const { id, navigate } = data;

      const response = await ordersApi.getEditOrder(id);

      if (response?.data?.status !== 'PENDING') {
        navigate(`/exchange/${id}/status`);
      }

      delete response?.data?.time_to_pay;
      delete response?.data?.created_at;
      delete response?.data?.transaction;

      return response?.data;
    } catch (error) {
      const { navigate } = data;

      navigate(ROUTE.HOME);

      console.error(error);
    }
  },
);

export const getOrderStatus = createAsyncThunk('orders/get-order-status', async (data) => {
  try {
    const { id } = data;

    const response = await ordersApi.getEditOrder(id);

    return response?.data;
  } catch (error) {
    const { navigate } = data;

    navigate(ROUTE.HOME);

    console.error(error);
  }
});

export const calculateOrderExchange = createAsyncThunk(
  'orders/calculate-order-exchange',
  async (data) => {
    try {
      const { id, payload } = data;

      const response = await ordersApi.calculateOrderExchange(id, payload);

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const validateCreateOrder = createAsyncThunk(
  'orders/validate-create-order',
  async (data, thunkApi) => {
    try {
      const { payload, navigate } = data;

      const copiedData = _.cloneDeep(payload);

      const response = await ordersApi.validateOrder(dumpCreateOrder(copiedData));

      thunkApi.dispatch(setSelectedOrder(dumpAcceptOrder(payload)));

      navigate(ROUTE.EXCHANGE.ACCEPT);

      return response?.data;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setOrderErrors(normalizeErrorResponse(response.data.errors)));

      console.error(error);
    }
  },
);

export const updateOrderStatus = createAsyncThunk(
  'orders/update-order-status',
  async (data, thunkApi) => {
    try {
      const { id, payload, navigate } = data;

      const response = await ordersApi.getOrderConfirm(id, payload);

      thunkApi.dispatch(getEditOrder({ id, navigate }));

      return response?.data;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setOrderErrors(normalizeErrorResponse(response.data.errors)));

      console.error(error);
    }
  },
);
